import { Component, OnInit } from '@angular/core';
import { IBidReport } from '../../models/IBidReport';
import { Observable } from 'rxjs';
import { ICountry } from '../../models/ICountry';
import { S1DataService } from '../../services/s1data.service';
import { FezaDataService } from '../../services/fezadata.service';
import { FileService } from '../../services/file.service';
import { environment } from '../../../environments/environment';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date';
import { Utils } from '../../Utils';
import * as moment from 'moment';
import { IItem } from '../../models/IItem';

@Component({
    selector: 'app-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {

    reportData: IBidReport;
    countries: Observable<Array<ICountry>>;
    bidReferenceClients: Observable<Array<IItem>>;
    isError: boolean;

  constructor(private dataService: S1DataService, private fileService: FileService, private fezaService: FezaDataService) {
        this.reportData = {
            endDate: null,
            startDate: this.setDefaultStartDate(),
            bidIds: "",
            referenceClient: "",
            country: ""
        };
    }

    ngOnInit() {
      this.countries = this.dataService.getCountries();
      this.bidReferenceClients = this.fezaService.getBidReferenceClients();
      this.isError = false;
    }


  setDefaultStartDate() {
      let date: Date = moment().subtract(1, 'month').toDate()
      return new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
    }

    checkNotAllFieldsEmpty(bidReport) {
        bidReport.bidIds = bidReport.bidIds.replace(/\s/g, ''); //remove spaces
        
        if (bidReport.startDate == null &&
            bidReport.endDate == null &&
            bidReport.bidIds.length == 0 &&
            bidReport.referenceClient.length == 0 &&
            (bidReport.country.length == 0 || bidReport.country == '-')) {
            this.isError = true;
            $("#errorInfo").append("<div>Please don't leave all the values empty</div>");
        }
    }

    runValidations(bidReport) {
        this.isError = false;
        $("#errorInfo").html("");
        this.checkNotAllFieldsEmpty(bidReport);
        this.checkStartDate(bidReport.startDate);
      this.checkBidReferenceClient(bidReport.referenceClient);
  }

  checkBidReferenceClient(refClient) {
    if (refClient === null || refClient === 'null' || refClient.length == 0) {
      this.isError = true;
      $("#errorInfo").append("<div>Please select Reference Client</div>");
    }
  }

    checkStartDate(startDate) {
        if (startDate === null) {
            this.isError = true;
            $("#errorInfo").append("<div>Start Date can not be empty</div>");
        }
    }


    getReport() {
        this.runValidations(this.reportData);//run validation
        if (!this.isError) {

            var startDate = Utils.formatNgbDateAsUTC(this.reportData.startDate);
            var endDate = Utils.formatNgbDateAsUTC(this.reportData.endDate);

            let url = environment.fezeUrl + `/api/v1/Report/BidIdReport?startDate=${startDate}&endDate=${endDate}&bidIds=${this.reportData.bidIds}&referenceClient=${this.reportData.referenceClient}&country=${this.reportData.country}`;
            this.fileService.downloadSecureFile(url, `Bid Report.xlsx`);
        }
    }

    getTargetedFirstFailedReasonsReport(){
        this.runValidations(this.reportData);//run validation
        if (!this.isError) {

            var startDate = Utils.formatNgbDateAsUTC(this.reportData.startDate);
            var endDate = Utils.formatNgbDateAsUTC(this.reportData.endDate);

            let url = environment.fezeUrl + `/api/v1/Report/TargetedFirstFailedReasons?startDate=${startDate}&endDate=${endDate}&bidIds=${this.reportData.bidIds}&referenceClient=${this.reportData.referenceClient}&country=${this.reportData.country}`;
            this.fileService.downloadSecureFile(url, `Targeted First Failed Reasons.xlsx`);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/report/report.component.ts